import { API_URL } from "Store/Shared/Middleware/API/Constants";
import { UserId } from "Store/User/PropTypes";
import { FETCH_ALL_SCOPES } from "./ActionTypes";

export function fetchAllScopes(id: UserId) {
    return {
        types: [
            FETCH_ALL_SCOPES.REQUEST,
            FETCH_ALL_SCOPES.SUCCESS,
            FETCH_ALL_SCOPES.FAILURE
        ],
        shouldCallAPI: (state: any) => (!state.api.scopes || !state.api.scopes[0]),
        callAPI: (accessToken: any) => fetch(
            API_URL + `/api/scopes`,
            {
                headers: {
                  Authorization: `Bearer ${accessToken}`
                }
            })
    }
}